import TechOverviewIcon from 'img/icons/techoverview-icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import { formatProductRows } from '../BodyBuilder/utils';

const techOverviewIconConfig: HeaderIconConfig = {
  backgroundColor: '#73804E',
  iconTitle: 'Delivery format: Technical Overview',
  src: TechOverviewIcon,
};

const techOverviewConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, hasProgress, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry, { hasProgress });
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Icons, BodyRowType.Custom],
  buildCustomRows: ({ offeringProducts }) =>
    formatProductRows(offeringProducts),
  headerConfig: ({ t }) => ({
    iconB: techOverviewIconConfig,
    title: t('Technical overview'),
  }),
  iconRowsLayout: () => [[IconLabel.Duration]],
};

export default techOverviewConfig;
